/**
 * 我的/历史-优惠券列表请求入参
 */
export interface CouponsRequest {
  couponStatus: number
  page: number
  pageSize: number
  topSortCouponViewId?: Array<string> // 需要置顶展示的券
}

/**
 * 提单页优惠券列表-请求入参
 */
export interface OrderCouponsRequest {
  userGetMode: string // 自提+外卖
  couponViewId: string // 优惠券viewId
  shopId: string // 门店id
  actualLongitude: string // 用户实际经度
  actualLatitude: string // 用户实际纬度
  addressInfo: AddressInfo // 接收人地址信息
  // fingerprint: string,            // 设备指纹
  // skuList: any[],              // 商品列表(sl暂时用不上)
  orderSource: number // 订单来源
  couponThresholdInfo: CouponThresholdInfo // 券列表相关门槛模块
  topSortCouponViewId?: Array<string> // 需要置顶展示的券
  appInstallationInfoList?: Array<object> // 用户app安装信息列表
  bundleVersion: string // bundleVersion
  orderToken: string // 提单页token
  apInputReqs?: ApInputRequest[] // 搭售选择入参
  apExtra?: any // 券列表请求的apExtra, 透传搭售额外参数
}

/**
 * 地址信息
 */
export interface CouponThresholdInfo {
  orderSillAmount: number // 用券门槛限制的的订单对比基数，单位分
  orderDiscountAmount: number // 计算优惠金额的订单价格基数，单位分
  deliveryDiscountPrice: number // 计算配送费券优惠金额的订单价格基数，单位分
}

/**
 * 券列表相关门槛模块
 */
export interface AddressInfo {
  addressId: number // 地址id
  receiverPhone: string // 接收人手机号
  receiverName: string // 接收人名称
  receiverLocation: string // 接收人地址（位置）
  receiverHouseNumber: string // 接收人地址门牌号
  receiverLongitude: string // 接收地址经度
  receiverLatitude: string // 接收地址纬度
  receiverInnerCode: string // 收货人手机号国际区号
  receiverAddress: string // POI点的名称
  addressLocationTips: string // 地址距离提示
}

/**
 * 我的/历史-优惠券数据结构
 */
export interface CouponInfo {
  couponBaseInfoDto: CouponBaseInfo
  couponDisplayInfoDto: CouponDisplayInfo
}

export interface CouponBaseInfo {
  couponViewId: string // 券id
  couponConfigId: number // 券配置id
  startTime: string // 券可用开始时间
  endTime: string // 券可用结束时间
  subCategory: number // 券子类型
  packSceneId: number // 券所在券包的类型
  bizLine?: CouponBizLineEnum // 业务线
}

export interface CouponDisplayInfo {
  name: string
  count: number // 券张数
  useRuleDocList: Array<string> // 券使用规则
  invalidReasonDocList: Array<string> // 券失效原因
  validTimeText: string // 有效期文案
  sillAmountText: string // 第一限制条件门槛文案：如满100可用、无门槛
  sillAmountString: string // 门槛金额：单位元
  noSill: boolean // 是否为无门槛
  couponAmountSplitResult: string // 小数点修改新增满减券数据结构
  couponAmountString: string // 券面价格：单位元，
  couponAmountText: string // 券面文案
  delivery: boolean
  currencyType: string // 单位：如HK$
  invalidDateText: string // 已使用/已过期时间
  buttonUrl: string // 跳转url
  buttonText: string // 跳转文案
  shortUseRuleDoc: string // 第二限制条件
  exchangeCode: string // 兑换码
  couponLabelInfo: CouponLabelInfo // 标签
  couponBackgroundInfo: CouponBackgroundInfo // 底纹图片url
  shortDescription: string // 运费优惠
  shortUseRuleDocList: string[] // 标签字段
  defaultUseCouponlink: string // 兜底跳转url
  inflateCouponDisplayInfo: InflateCouponDisplayInfo // 膨胀券信息，与券系统保持一致
}

/**
 * 提单页优惠券列表-数据结构
 */
export interface OrderCouponInfo {
  couponViewId: string // 券Id
  couponConfigId: number // 券配置Id
  name: string // 优惠券名称
  discountType: number // 折扣类型
  useRuleDocList: Array<string> // 券的使用规则说明文案
  unusableReasonDocList: Array<string> // 券不可用原因列表。用于提单页可用券列表，当前订单不可用的券需要展示不可用原因
  validTimeText: string // 优惠券有效期文案
  sillAmountText: string // 1、使用门槛限制，订单满多少才能使用文案；2、最高抵扣金额文案，app4.6新属性
  sillAmountString: string // 门槛金额信息，保留两位小数，末尾去0
  maxDeductAmountDoc: string // 最高抵扣金额文案，如：最高减少$50 （本次字段拆分暂无意义）
  selected: boolean // 券是否勾选 true:勾选 false未勾选
  couponAmountSplitResult: string // 小数点修改新增满减券数据结构
  couponAmountString: string // 券金额（20）
  couponAmountText: string // 最高减（本期免运费券是固定返回文本）
  couponValidTime: number // 券剩余时间
  currencyType: string // 币种（$）
  shortUseRuleDoc: string // 第二限制条件
  exchangeCode: string // 兑换码
  couponLabelInfo: CouponLabelInfo // 标签
  couponBackgroundInfo: CouponBackgroundInfo // 底纹图片url
  shortDescription: string // 运费优惠
  couponReminderInfo: CouponReminderInfo // 券点击事件等的提醒信息
  payChannelInfo: PayChannelInfo // 支付渠道限制信息
  firstOrderLimit: boolean // 是否限首单用户券
  subCategory: number // 券子类型
  expiredDay: number | string //
  shortUseRuleDocList: string[] // 标签字段
  inflateCouponInfo: InflateCouponDisplayInfo // 膨胀券信息，与券系统保持一致
  extra: any // 额外信息
}

// export interface MCurrencySplitResult {
//   decimal: string
//   displayText: string
//   numberText: string
//   symbolText: string
//   group: string
// }

/**
 * 券样式背景图
 */
export interface CouponBackgroundInfo {
  couponAmountBackgroundUrl: string // 券样式底纹图片url
  useRulePopupCouponAmountBackgroundUrl: string // 券规则底纹图片url
}

/**
 * 券卡提示信息-数据结构
 */
export interface CouponReminderInfo {
  type: number // 提醒信息类型，1-支付渠道限制
  title: string // 提醒标题
  content: string // 提醒内容信息
}

/**
 * 支付渠道限制信息
 */
export interface PayChannelInfo {
  payChannelCodeList: any[] // 支付渠道编码列表
}

/**
 * 券卡提示信息-数据结构
 */
export interface CouponLabelInfo {
  couponActLabelUrl: string // 券活动标签地址
}

/**
 * 我的券列表页-券兑换请求入参
 */
export interface MyCouponsExchangeRequest {
  exchangeCode: string // 口令码
  idempotentKey: string // 幂等key(唯一标识一次请求，目的是避免重试多发券）
  actualLatitude: number // 物理纬度
  actualLongitude: number // 物理经度
}

/**
 * 兑换券相关信息
 */
export interface CouponExchangeDetail {
  couponViewId: string // 券展示id（不是配置id，是领券时候生产的id），兑换成功时，置顶高亮展示的标识
  couponReminderInfoDto: CouponReminderInfo // 支付渠道信息
  firstOrderLimit: boolean // 是否限首单用户券
  hasFirstOrderCoupon: boolean // 是否有首单券
}

// /**
//  * 支付渠道信息
//  */
// export interface CouponReminderInfo {
//   type: number,                       // 支付渠道编码列表，如'alipay_hk'等
//   title: string,                      // 支付渠道提示标题
//   content: string                     // 支付渠道提示内容
// }

/**
 * 提单券列表页-券兑换请求入参
 */
export interface OrderCouponsExchangeRequest {
  exchangeCode: string // 兑换券码
  shopId: string // 门店id
  actualLongitude: string // 用户实际经度
  actualLatitude: string // 用户实际纬度
  addressInfo: AddressInfo // 接收人地址信息
  orderSource: number // 订单来源
  couponThresholdInfo: CouponThresholdInfo // 券列表相关门槛模块
  topSortCouponViewId?: Array<string> // 需要置顶展示的券
  appInstallationInfoList?: Array<object> // 用户app安装信息列表
  userGetMode: string // 自提/外卖
  bundleVersion: string // bundleVersion
}

/**
 *资源位降级开关
 *  */
export interface PositionSwitchRequest {
  channelId: string // 资源位key
  version: string // 版本号
}

/**
 *资源位
 *  */
export interface PositionRequest {
  channelId: string // 资源位key
}

/**
 * 提单券列表页-搭售选择入参
 */
export interface ApInputRequest {
  type: number
  productId: string
  productBuyId: string
  selected: boolean
  extendParam?: string // 仅勾选时传
}

export interface InflateCouponDisplayInfo {
  canUpgrade?: boolean // 是否可膨
  inflateCouponType?: number // 膨后券类型（0代表非膨后券，1代表膨后券，用数字是因为后续膨后券可能扩展类型）
  upgradeAmount?: number // 如果可膨，膨后券的金额
  upgradeAmountText?: string // 如果可膨，膨后券的金额，单位元或同类单位，保留两位小数，末尾去0
  upgradeSillAmount?: number // 如果可膨，膨后券的门槛
  upgradeSillAmountText?: string // 如果可膨，膨后券的门槛，单位元或同类单位，保留两位小数，末尾去0
  upgradeExpireTimeText?: string // 如果可膨，膨后券的截止时间文案，有效期至YYYY.MM.DD
  upgradeCouponConfigId?: number[] // 膨后券ID
  canDowngrade?: boolean // 是否可逆膨
  downgradeAmount?: number // 如果可逆，逆膨后的金额
  downgradeAmountText?: string // 如果可逆，逆膨后的金额，单位元或同类单位，保留两位小数，末尾去0
  downgradeSillAmount?: number // 如果可逆，逆膨后的门槛
  downgradeSillAmountText?: string // 如果可逆，逆膨后的门槛，单位元或同类单位，保留两位小数，末尾去0
}

/**
 * 我的/提单券列表-券膨胀接口
 */
export interface CouponUpgradeRequest {
  upgradeCouponInfo: {
    fromCouponConfigId: number
    fromCouponViewId: string
    upgradeAfterInfoList: {
      toCouponConfigId: number
      sellInfo: {
        sillAmount: number
        couponAmount: number
      }
    }[]
  }
  source: number
  shopId?: string // 门店id
  riskApiCommonParam: {
    actualLongitude: string
    actualLatitude: string
    homePageLongitude: string
    homePageLatitude: string
  }
}

/**
 * 我的/提单券列表-券逆膨接口
 */
export interface CouponDowngradeRequest {
  fromCouponViewId: string
  source: number
  riskApiCommonParam: {
    actualLongitude: string
    actualLatitude: string
    homePageLongitude: string
    homePageLatitude: string
  }
}

/** 券业务线类型枚举 */
export enum CouponBizLineEnum {

  /** 外卖 */
  KFOOD = 'kfood',

  /** 小象 */
  KEEMART = 'keemart',

  /** 境外无人机 */
  KDRONE = 'kdrone',

  /** 境外saas */
  SAAS = 'saas',

  /** 境外充电宝 */
  CHARGE = 'charge',
}
